import styled from 'styled-components'

export const hideDimensionsStyles = styled.div`
  .lfc-configurator > section {
    &:has(*) {
      display: none !important;
    }

    ${(props) =>
      props.visibleDimenesionsIds.map(
        (id) => `
      &:has(label[for=d${id}]) {
        display: flex !important;
      }
    `
      )}

    & > div {
      &:has(*) {
        display: none !important;
      }

      ${(props) =>
        props.visibleDimenesionsIds.map(
          (id) => `
      &:has(label[for=d${id}]) {
        display: revert !important;
      }
    `
        )}
    }
  }

  /* Fallback CSS when :has is not supported (https://caniuse.com/css-has) */
  .lfc-configurator > section > div {
    & > label,
    & > label ~ * {
      display: none !important;
    }

    ${(props) =>
      props.visibleDimenesionsIds.map(
        (id) => `
      & > label[for=d${id}] {
        display: inline-block !important;

        & ~ button {
          display: inline-flex !important;
        }

        & ~ div,
        & ~ ul {
          display: flex !important;
        }
      }
    `
      )}
  }
`
